import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StartPageComponent } from './start-page.component';
import { SharedComponentsModule } from '.././../shared-components/shared-components.module';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    SharedComponentsModule,
    RouterModule
  ],

  exports: [
    StartPageComponent
  ],
  declarations: [
    StartPageComponent
  ]
})
export class StartPageModule { }



// WEBPACK FOOTER //
// G:/Projekty/swaythegame/src/app/views/start-page/start-page.module.ts